import React from 'react'
import './Services.css'

const Services = () => {
    const clientdata = [
        {
            name: 'FAST FREE SHIPPING',
            image: '/assets/images/home/services/shipping.png'
        },
        {
            name: '3 YEARS WARRANTY',
            image: '/assets/images/home/services/warranty.png'
        },
        {
            name: '20+ YRS OF EXPERIENCE',
            image: '/assets/images/home/services/experience.png'
        },
        {
            name: 'LIFETIME SUPPORT',
            image: '/assets/images/home/services/support.png'
        },

    ];
    return (
        <>
            <section className='Services_sec'>
                <div className='container'>
                    <div className='clientssec'>
                        <div className='row'>
                            {clientdata.map((data, index) => (
                                <div className='col-lg-3 col-sm-6 mb-3'>
                                    <div className='custbox'>
                                        <div className='icondiv'>
                                            <img className='img' src={data.image} alt="icon" />
                                        </div>
                                        <div className='contdiv'>
                                            <p className='name'>{data.name}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Services